export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  CALL_CENTER_AGENT = 'CALL_CENTER_AGENT',
  FINANCIAL_ADMIN = 'FINANCIAL_ADMIN'
}

export interface User {
  id: string;
  email: string;
  fullName: string;
  phone: string;
  role: UserRole;
  companyId?: string;
  avatarUrl?: string;
  createdAt: Date;
}
